"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRouterMap = void 0;
exports.resetRouter = resetRouter;

var _toConsumableArray2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _interopRequireWildcard2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

var _vue = _interopRequireDefault(require("vue"));

var _vueRouter = _interopRequireDefault(require("vue-router"));

var _report = require("@/config/report");

var _layout = _interopRequireDefault(require("@/layout"));

_vue.default.use(_vueRouter.default);
/* Layout */


// const reportRouter = []
var reportNav = [].concat(_report.reportNavList, _report.excludeReportNavList); // for (let i = 0; i < reportNav.length; i++) {
//   reportRouter.push({
//     path: reportNav[i].path + '/:projectId/:reportId',
//     name: reportNav[i].name,
//     component: reportNav[i].component,
//     meta: { title: reportNav[i].title }
//   })
// }

var constantRouterMap = [{
  path: '/login',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/login/index'));
    });
  },
  hidden: true
}, {
  path: '/',
  component: _layout.default,
  redirect: '/home',
  children: [{
    path: '/home',
    name: 'Home',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/home/index'));
      });
    },
    meta: {
      title: '首页'
    }
  }, {
    path: '/govip',
    name: 'GoVIP',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/home/goVip'));
      });
    },
    meta: {
      title: '购买VIP'
    }
  }]
}, {
  path: '/pay',
  component: _layout.default,
  children: [{
    path: '/pay/count',
    name: 'PayCount',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/pay/count'));
      });
    },
    meta: {
      title: '购买次数'
    }
  }, {
    path: '/pay/vip',
    name: 'PayVip',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/pay/vip'));
      });
    },
    meta: {
      title: '购买次数'
    }
  }]
}, {
  path: '/project',
  component: _layout.default,
  children: [{
    path: '/project/:id',
    name: 'ProjectIndex',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/project/index'));
      });
    },
    meta: {
      title: '项目首页'
    }
  }, {
    path: '/project/info/:id',
    name: 'ProjectInfo',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/project/info'));
      });
    },
    meta: {
      title: '项目详情'
    }
  }]
}, {
  path: '/user',
  component: _layout.default,
  children: [{
    path: '/user',
    name: 'User',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/user/index'));
      });
    },
    meta: {
      title: '用户信息'
    }
  }]
}, {
  path: '/report',
  component: _layout.default,
  redirect: reportNav[0].path,
  children: (0, _toConsumableArray2.default)(reportNav)
}, {
  path: '/404',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/404'));
    });
  },
  hidden: true
}, // 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
exports.constantRouterMap = constantRouterMap;

var createRouter = function createRouter() {
  return new _vueRouter.default({
    mode: 'hash',
    // require service support  history
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRouterMap
  });
};

var router = createRouter(); // Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465

function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

var _default = router;
exports.default = _default;